import React from "react";

const About = () => {
  return (
    <div className="">
      {/* Overview Section (Gradient with a Soft Background) */}
      <div className="container mt-12 mx-auto py-20 px-6 bg-gradient-to-r from-[#ae3e34] to-[#f7b6a5] text-white rounded-lg shadow-lg mb-12">
        <h1 className="text-5xl font-semibold text-center mb-6">About Us</h1>
        <p className="text-lg text-center mb-8 max-w-3xl mx-auto">
          Bricks N Bar is a leading provider of quality building materials and
          construction solutions, dedicated to providing a seamless online
          shopping experience for all your construction needs.
        </p>
      </div>

      {/* Vision Section (Light Gradient with Rounded Corners) */}
      <div className="py-16 bg-gradient-to-r from-gray-50 to-gray-100 rounded-lg shadow-md">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-semibold text-[#ae3e34] mb-4">
            Our Vision
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto mb-8">
            To be the most trusted and preferred partner in the construction
            industry, empowering builders with the tools and resources they need
            to succeed.
          </p>
        </div>
      </div>

      {/* Values Section (Split Layout with Icons and Text) */}
      <div className="py-16 bg-gray-100">
        <div className="container mx-auto px-6 text-center md:text-left">
          <h2 className="text-3xl font-semibold text-[#ae3e34] mb-4 text-center">
            Our Values
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div className="flex flex-col items-center">
              <div className="text-4xl text-[#ae3e34] mb-4">💎</div>
              <p className="text-lg text-gray-700 max-w-xs mx-auto">
                Integrity: We uphold the highest standards of honesty and
                fairness in all our dealings.
              </p>
            </div>
            <div className="flex flex-col items-center">
              <div className="text-4xl text-[#ae3e34] mb-4">🔧</div>
              <p className="text-lg text-gray-700 max-w-xs mx-auto">
                Quality: We deliver top-notch products with impeccable
                craftsmanship and durability.
              </p>
            </div>
            <div className="flex flex-col items-center">
              <div className="text-4xl text-[#ae3e34] mb-4">🚀</div>
              <p className="text-lg text-gray-700 max-w-xs mx-auto">
                Innovation: We embrace new technologies and ideas to stay ahead
                in the market.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Section (Soft Background with a Centered Form) */}
      <div className="py-16 bg-gradient-to-l from-gray-50 to-gray-100">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-semibold text-[#ae3e34] mb-4">
            Contact Us
          </h2>
          <p className="text-lg text-gray-700 mb-4">
            Have any questions or want to know more? Feel free to reach out to
            us!
          </p>
          <p className="text-lg text-gray-700 mb-4">
            Email:{" "}
            <a
              href="mailto:info@bricksnbar.com"
              className="text-[#ae3e34] hover:underline"
            >
              info@bricksnbar.com
            </a>
          </p>
          <p className="text-lg text-gray-700 mb-4">
            Phone: <span className="font-semibold">+123-456-7890</span>
          </p>
          <div className="flex justify-center mt-6">
            <a
              href="#"
              className="bg-[#ae3e34] text-white py-2 px-6 rounded-md text-lg font-semibold hover:bg-[#8d2e28] transition-colors"
            >
              Get In Touch
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
